import React, {useEffect, useState} from "react";
import ApiRoute from "../../../helper/api";
import Layout from "../../../components/Layout";
import {ToastContainer} from "react-toastify";
import {Step5} from "../../../components/Product/Step/Step-5";

function CreateProductStep5() {
    const [product,setProduct] = useState({})
    const [loading,setLoading] = useState(true)
    const search = window.location.search;
    const params = new URLSearchParams(search);

    useEffect(() => {

        (async () => {
            const response = await ApiRoute.product.single.fn( params.get('product_id') )
            setProduct(response.results)
        })()


    }, []);


    return (
        <Layout>
            {product &&  <Step5 defaultProduct={product}/>}

        </Layout>
    )
}

export default CreateProductStep5